export const DEFAULT_FORMATS = 'jpg, png, pdf, tiff, tif';
export const DEFAULT_TITLE = 'Choose a file or drag & drop it here.';

export const DOCUMENT_TYPES = {
  'application/pdf': 'file-pdf',
  'image/jpeg': 'file-jpg',
  'image/png': 'file-png',
  'image/tiff': 'file-image',
  'image/tif': 'file-image',
  'text/plain': 'file-txt',
  'text/rtf': 'file-default',
  'text/csv': 'file-csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-xls',
  'application/json': 'file-json',
  'application/zip': 'file-zip'
};

export const STATUSES = {
  uploading: 'Uploading...',
  uploaded: 'Completed',
  failed: 'Failed'
};

export const ICON_TYPES = {
  uploading: 'loader',
  uploaded: 'checkmark-circle',
  failed: 'info-filled'
};

export const TRY_AGAIN_LABEL = 'Try again';
